export default __webpack_public_path__ + "static/media/pexels-engin-akyurt-1457801.0dec357c.jpg";